var render, staticRenderFns
import script from "./groupItem.vue?vue&type=script&lang=js"
export * from "./groupItem.vue?vue&type=script&lang=js"
import style0 from "./groupItem.vue?vue&type=style&index=0&id=3408001e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408001e",
  null
  
)

export default component.exports